<template>
  <div class="card dash-card headercard" style="margin-top:2px; min-height:281px; height:480px;">
    <ProcessExcellenceHeader :dashdata="dashdata" />

    <div class="card-body p-0 m-0">
      <div class="il-table">
        <div class="il-row">
          <!-- Cluster 1 Contact Initiation -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi1_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi1_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi1_2" />
            </div>
          </div>

          <!-- Cluster 2 Lamborghini CI -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi2_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi2_1 !== undefined" />

            <div class="dash-card-inner">
              <!-- <tableitem :overallByWave="getOverallByWave"
                          :kpi="getKpi5_1" hasStar="true"  />

              <tableitem :overallByWave="getOverallByWave"
              :kpi="getKpi6" hasStar="true" />-->
            </div>
          </div>

          <!-- Cluster 3 Welcome -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi3_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi3_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi3_2" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi3_3" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi3_4" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi3_5" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi3_6" />
            </div>
          </div>

          <!-- Cluster 4 Est. Customer Requirements -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi4_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi4_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi4_2" />
            </div>
          </div>

          <!-- Cluster 5 New Vehicle Presentation -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi5_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi5_1 !== undefined" />

            <div class="dash-card-inner">
              <!-- Unterschied zw. "05. Follow-up on Offer" und "09. Follow-up on Offer"? -->
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi5_2" />
            </div>
          </div>

          <!-- Cluster 6 Test Drive -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi6_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi6_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi6_2" />
            </div>
          </div>

          <!-- Cluster 7 Offer / Negotiation -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi7_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi7_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi7_2" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi7_3" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi7_4" />

              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi7_5" />
            </div>
          </div>

          <!-- Cluster 8 Follow Up -->
          <div class="il-cell">
            <tableitem  :overallByWave="getOverallByWave"
                        :kpi="getKpi8_1"
                        :hideNSC="true"
                        :isHeader="true" />
            <titleunderline :hasKpi="getKpi8_1 !== undefined" />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpi8_2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import performanceitem from "./PerformanceItem";
import tableitem from "./TableItem.vue";
import titleunderline from "./TitleUnderline";
import ProcessExcellenceHeader from "./ProcessExcellenceHeader";
import KpiMixin from '@/mixins/lambo/KpiMixin';

export default {
  name: "LamboProcessExcellenceColumn",

  components: {
    performanceitem,
    tableitem,
    titleunderline,
    ProcessExcellenceHeader,
  },

  mixins: [ KpiMixin ],

  computed: {
    getKpi1_1: function () {
      return (
        this.getKpiByString("1. Telephone Enquiry") ||
        this.getKpiByString("1. Welcome") ||
        this.getKpiByString("1.2 Telephone Enquiry")
      );
    },
    getKpi1_2: function () {
      return (
        this.getKpiByString("1.7 The operator scheduled the appointment within 3 working days?") ||
        this.getKpiByString("1.1 When did you reach anyone at the dealership?") ||
        this.getKpiByString("1.2.8 The operator scheduled the requested streaming appointment within 3 working days?") ||
        this.getKpiByString("1.8 The operator scheduled the requested streaming appointment within 3 working days?")
      );
    },

    getKpi2_1: function () {
      return (
        this.getKpiByString("2. Showroom environment") ||
        this.getKpiByString("2. Establishing customer requirements") ||
        this.getKpiByString("2. Establishing customer requirements") ||
        this.getKpiByString("2. Streaming Platform")
      );
    },

    getKpi3_1: function () {
      return (
        this.getKpiByString("3. Welcome") ||
        this.getKpiByString("3. Booking") ||
        this.getKpiByString("3. Problem Solving / Booking")
      );
    },
    getKpi3_2: function () {
      return (
        this.getKpiByString(
          "3.1.1 You were welcomed by a Salesperson or another employee of the dealership within 5 minutes?"
        ) ||
        this.getKpiByString(
          "3.0-3.1 Did you get an appointment for the service inspection within 3 calendar days? "
        ) ||
        this.getKpiByString(
          "3.1 You were welcomed by a Salesperson or another employee of the dealership within 5 minutes?"
        )
      );
    },
    // Aftersales only
    getKpi3_3: function () {
      return (
        this.getKpiByString(
          "3.10 Did the service person request your contact information for double checking them? "
        ) || this.getKpiByString("3.6 Contact information")
      );
    },
    getKpi3_4: function () {
      return this.getKpiByString(
        "3.7 Once requested, did the service person throughly explain the accessory offer and availability?"
      );
    },

    getKpi3_5: function () {
      return this.getKpiByString("3a. Problem Solving");
    },

    getKpi3_6: function () {
      return this.getKpiByString("3b. Booking");
    },

    getKpi4_1: function () {
      return (
        this.getKpiByString("4. Establishing customer requirements") ||
        this.getKpiByString("4. Follow up call (only if applicable (Q3.4))") ||
        this.getKpiByString("4. Follow up call") ||
        this.getKpiByString("4. Follow up call ")
      );
    },
    getKpi4_2: function () {
      return (
        this.getKpiByString("4.1-4.1.11 Customer needs") ||
        this.getKpiByString("4.1-4.2 Follow up") ||
        this.getKpiByString("4.1 - 4.1.9 Customer needs") ||
        this.getKpiByString("4.0-4.1 Follow up") ||
        this.getKpiByString("4.1 - 4.1.11 Customer needs")        
      );
    },

    getKpi5_1: function () {
      return (
        this.getKpiByString("5. New vehicle presentation") ||
        this.getKpiByString("5. Evaluation of dealer proposition to sell") ||
        this.getKpiByString("5. Pre-owned vehicle presentation") ||
        this.getKpiByString("5. Vehicle presentation") ||
        this.getKpiByString("5. New vehicle presentation online")        
      );
    },
    getKpi5_2: function () {
      return (
        this.getKpiByString("5.5.6-5.5.7 Brand and Car presentation") ||
        this.getKpiByString("5.6.4-5.6.5 Brand and Car presentation")
      );
    },

    getKpi6_1: function () {
      return this.getKpiByString("6. Test Drive");
    },
    getKpi6_2: function () {
      return this.getKpiByString(
        "6.1 Did the Salesperson actively offer a test drive?"
      );
    },

    getKpi7_1: function () {
      return this.getKpiByString("7. Offer/Negotiation");
    },
    getKpi7_2: function () {
      return (
        this.getKpiByString("7.1.2 The Salesperson asked for your personal data and permission to use this data for the offer?") ||
        this.getKpiByString("7.1.1 The Salesperson asked for your complete personal data and the permission to data handling in order to fill in thoroughly the offer?")
      );      
    },
    getKpi7_3: function () {
      return (
        this.getKpiByString(
          "7.2.1 The Salesperson asked if you have a used vehicle to trade in?"
        ) ||
        this.getKpiByString(
          "7.2 The Salesperson asked if you have a used vehicle to trade in?"
        )
      );
    },
    getKpi7_4: function () {
      return (
        this.getKpiByString(
          "7.4.1 Did the Salesperson actively propose a written offer?"
        ) ||
        this.getKpiByString(
          "7.4 Did the Salesperson actively propose a written offer?"
        )
      );
    },
    getKpi7_5: function () {
      return this.getKpiByString(
        "7.5.1 The Salesperson communicated spontaneously the expected delivery timing?"
      );
    },

    getKpi8_1: function () {
      return this.getKpiByString("8. Follow up");
    },
    getKpi8_2: function () {
      return (
        this.getKpiByString("8.1 The Salesperson reached you on the phone or by email within 7 working days?") ||
        this.getKpiByString("8.2 The Salesperson reached you on the phone or by email within 7 working days?")
      );
    }
  },
};
</script>